import React, { useEffect, useState } from 'react';
import { 
  AreaChart, Area, XAxis, YAxis, CartesianGrid, 
  Tooltip, ResponsiveContainer 
} from 'recharts';
import './BookingChart.css'
import { supabase } from '../../supabase';

// const data = [
//   { name: 'JAN', total: 400 },
//   { name: 'FEB', total: 300 },
//   { name: 'MAR', total: 600 },
//   { name: 'APR', total: 800 },
//   { name: 'MAY', total: 500 },
//   { name: 'JUN', total: 900 },
// ];

const BookingChart = () => {

  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchAndFormatChartData = async () => {

      const { data, error } = await supabase
        .from('bookings')
        .select('created_at');

      if (error) {
        console.error("Error fetching chart data:", error);
        return;
      }


      const monthsMap = {
        'JAN': 0, 'FEB': 0, 'MAR': 0, 'APR': 0, 'MAY': 0, 'JUN': 0,
        'JUL': 0, 'AUG': 0, 'SEP': 0, 'OCT': 0, 'NOV': 0, 'DEC': 0
      };


      data.forEach(booking => {
        if (booking.created_at) {
          const date = new Date(booking.created_at);

          const monthKey = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
          if (monthsMap[monthKey] !== undefined) {
            monthsMap[monthKey]++;
          }
        }
      });

      const formattedData = Object.keys(monthsMap).map(monthName => ({
        name: monthName,
        total: monthsMap[monthName]
      }));

      setChartData(formattedData.slice(0, 6)); 
    };

    fetchAndFormatChartData();
  }, []);

  return (
    <div className="ChartContainer">
      <div className="ChartHeader">
        <div>
          <h3>Booking Trends</h3>
          <p>Monthly ticket reservations across all categories</p>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#56FF50" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#56FF50" stopOpacity={0}/>
            </linearGradient>
          </defs>
          
          <CartesianGrid vertical={false} stroke="#2D2D2D" />
          
          <XAxis 
            dataKey="name" 
            axisLine={false} 
            tickLine={false} 
            tick={{fill: '#999', fontSize: 12}} 
            dy={10}
          />
          
          <YAxis hide={true} />
          
          <Tooltip 
            contentStyle={{ backgroundColor: '#1A1A1A', border: 'none', borderRadius: '8px' }}
            itemStyle={{ color: '#56FF50' }}
          />

          <Area 
            type="monotone" 
            dataKey="total" 
            stroke="#56FF50" 
            strokeWidth={3}
            fillOpacity={1} 
            fill="url(#colorTotal)" 
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BookingChart;